// extracted by mini-css-extract-plugin
module.exports = {"body":"style__body__Z3zFD","content":"style__content__792vx","footer":"style__footer__fKu5+"};